import styled from "styled-components"

export interface StyledPillProps {
  pill_theme: string
}

export const StyledPillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -4px;
`

export const StyledPill = styled.div<StyledPillProps>`
  padding: 8px 16px;
  margin: 4px;
  border-radius: 64px;
  white-space: nowrap;
  color: ${props => props.theme.colors.white};
  ${props => props.pill_theme === "light" && `
    background-color: ${props.theme.colors.darkGrey05};
    color: ${props.theme.colors.darkGrey};
  `}
  ${props => props.pill_theme === "dark" && `
    background-color: ${props.theme.colors.darkGrey};
  `}
  ${props => props.pill_theme === "undergraduate" && `
    background-color: ${props.theme.colors.undergraduate};
  `}
  ${props => props.pill_theme === "masters" && `
    background-color: ${props.theme.colors.masters};
  `}
  ${props => props.pill_theme === "mba" && `
    background-color: ${props.theme.colors.mba};
  `}
  ${props => props.pill_theme === "doctorate" && `
    background-color: ${props.theme.colors.doctorate};
  `}
  ${props => props.pill_theme === "executive" && `
    background-color: ${props.theme.colors.executive};
  `}
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 6px 12px;
    border-radius: 24px;
  }

  & p{
    ${(props) => props.theme.mixins.body}
    margin: 0;
    color: inherit;
  }
`
